import { Theme } from '@mui/material';

const sxDataGrid = (theme: Theme) => {
	return {
		fontSize: '0.82rem',
		border: 'none',
		margin: '0px',
		padding: '0px',
		borderRadius: '10px',
		backgroundColor: theme.palette.background.paper,
		color: theme.palette.primary.main,
		'& .MuiDataGrid-columnHeaderTitle': {
			fontSize: '0.82rem',
			color: theme.palette.mode === 'dark' ? '#FFF' : '#6F8098',
			fontWeight: 600,
			overFlow: 'visible',
		},
		'& .MuiDataGrid-iconSeparator': {
			display: 'none',
		},
		'& .row-status--true': {
			color: '#8799B4',
		},
		'& .MuiDataGrid-columnHeaders': {
			border: 'none',
		},
		'& .MuiDataGrid-cell': {
			border: 'none',
		},
		'& .MuiTablePagination-actions': {
			'& .Mui-disabled': {
				color: '#6F8098!important',
			},
		},
		'& .MuiDataGrid-footerContainer': {
			borderTop: '1px solid rgba(0,0,0,0.1)',
		},
		'& .MuiDataGrid-overlay': {
			background: 'none!important',
		},
		'& .MuiCheckbox-root.Mui-checked': {
			color: theme.palette.secondary.main,
		},

		'& .MuiDataGrid-virtualScroller': {
			'&::-webkit-scrollbar': {
				width: '0.5rem',
			},
			'&::-webkit-scrollbar-track': {
				borderRadius: '0.5rem',
				padding: '15px 0',

				background: theme.palette.mode === 'dark' ? '#1A2B48' : '#F2F2F2',
			},
			'&::-webkit-scrollbar-thumb': {
				background: theme.palette.mode === 'dark' ? '#F2F2F2' : '#1A2B48',
			},
			'&::-webkit-scrollbar-thumb:hover': {
				background: theme.palette.mode === 'dark' ? '#F2F2F2' : '#1A2B48',
			},
			'&::-webkit-scrollbar-thumb:vertical': {
				borderRadius: '0.5rem',
			},
			'&::-webkit-scrollbar-thumb:horizontal': {
				borderRadius: '0.5rem',
			},
		},
	};
};

export default sxDataGrid;
